// extracted by css-extract-rspack-plugin
export default {"wrapper":"RszFQ","container":"IVpN3"};